import _objectSpread from "D:/git/vue-vuecmf-editor/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-496241ea"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "editor-tool-bar"
};
var _hoisted_2 = ["innerHTML"];

var _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("legend", null, "表格", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("legend", null, "列头", -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("legend", null, "支持三种视频文件格式（MP4、WebM、Ogg）", -1);
});

var _hoisted_12 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_14 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "about"
  }, [/*#__PURE__*/_createElementVNode("strong", null, "Vuecmf editor"), /*#__PURE__*/_createElementVNode("div", null, "HTML5富文本编辑器"), /*#__PURE__*/_createElementVNode("div", null, "版本：1.3.2"), /*#__PURE__*/_createElementVNode("div", null, "基于MIT开源协议"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("特别感谢："), /*#__PURE__*/_createElementVNode("a", {
    href: "https://v3.cn.vuejs.org",
    target: "_blank"
  }, "vuejs"), /*#__PURE__*/_createTextVNode(", "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://element-plus.org",
    target: "_blank"
  }, "Element Plus"), /*#__PURE__*/_createTextVNode(", "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://fontawesome.com",
    target: "_blank"
  }, "Font Awesome"), /*#__PURE__*/_createElementVNode("br")]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("© 2022 "), /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.vuecmf.com",
    target: "_blank"
  }, "www.vuecmf.com"), /*#__PURE__*/_createTextVNode(" All rights reserved.")])], -1);
});

var _hoisted_17 = {
  class: "about"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode("关闭");

import { defineComponent } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHeading, faAlignLeft, faAlignCenter, faAlignRight, faBold, faItalic, faUnderline, faStrikethrough, faSubscript, faSuperscript, faQuoteLeft, faLink, faIndent, faListOl, faListUl, faCopy, faUnlink, faOutdent, faCut, faPaste, faObjectGroup, faRemoveFormat, faRedo, faUndo, faQuestionCircle, faFont, faTextHeight, faGlassMartiniAlt, faGlassMartini, faArrowsAltH, faTable, faImage, faFilm, faCode } from '@fortawesome/free-solid-svg-icons';
library.add(faHeading, faAlignLeft, faAlignCenter, faAlignRight, faBold, faItalic, faUnderline, faStrikethrough, faSubscript, faSuperscript, faQuoteLeft, faLink, faIndent, faListOl, faListUl, faCopy, faUnlink, faOutdent, faCut, faPaste, faObjectGroup, faRemoveFormat, faRedo, faUndo, faQuestionCircle, faFont, faTextHeight, faGlassMartiniAlt, faGlassMartini, faArrowsAltH, faTable, faImage, faFilm, faCode);

var __default__ = defineComponent({
  name: 'vuecmf-editor',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  }
});

import { toRefs } from 'vue';
import Service from "./Service";
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: {
    //编辑器ID
    id: {
      type: String,
      required: true
    },
    //编辑器内容
    content: {
      type: String,
      default: ''
    },
    //编辑器高度
    height: {
      type: String,
      default: '300px'
    },
    //自定义工具条， 多个英文逗号分隔
    tools: {
      type: String,
      default: ''
    },
    //编辑器中按钮、输入框的统一大小样式
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['default', 'large', 'small'].indexOf(value) !== -1;
      }
    }
  },
  emits: ['onChange'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    var _toRefs = toRefs(props),
        id = _toRefs.id,
        content = _toRefs.content,
        height = _toRefs.height,
        tools = _toRefs.tools; //初始化服务类


    var service = new Service(id, content, emit, tools === null || tools === void 0 ? void 0 : tools.value);
    var editor_ref = service.editor_ref; //工具条功能配置

    var editor_tool_config = service.editor_tool_config;
    var about_dlg = service.about_dlg; //文本颜色设置

    var color_value = service.color_value;
    var bg_color_value = service.bg_color_value;
    var predefine_colors = service.predefine_colors; //插入超链接相关

    var link_dlg = service.link_dlg;
    var link_url = service.link_url;
    var link_target = service.link_target; //插入表格相关

    var table_dlg = service.table_dlg;
    var table_row = service.table_row;
    var table_col = service.table_col;
    var table_border_color = service.table_border_color;
    var table_width = service.table_width;
    var table_head = service.table_head;
    var table_head_bg_color = service.table_head_bg_color;
    var table_head_color = service.table_head_color; //插入图片相关

    var image_dlg = service.image_dlg;
    var image_url = service.image_url;
    var image_width = service.image_width;
    var image_height = service.image_height;
    var image_align = service.image_align; //插入视频相关

    var video_dlg = service.video_dlg;
    var video_url = service.video_url;
    var video_width = service.video_width;
    var video_height = service.video_height;
    var video_align = service.video_align; //插入代码相关

    var code_dlg = service.code_dlg;
    var code_content = service.code_content; //事件

    var linkEvent = service.linkEvent;
    var insertTableEvent = service.insertTableEvent;
    var insertImageEvent = service.insertImageEvent;
    var insertVideoEvent = service.insertVideoEvent;
    var insertCodeEvent = service.insertCodeEvent;

    var showLinkDlg = function showLinkDlg() {
      return link_dlg.value = false;
    };

    var showTableDlg = function showTableDlg() {
      return table_dlg.value = false;
    };

    var showImageDlg = function showImageDlg() {
      return image_dlg.value = false;
    };

    var showVideoDlg = function showVideoDlg() {
      return video_dlg.value = false;
    };

    var showCodeDlg = function showCodeDlg() {
      return code_dlg.value = false;
    };

    var showAboutDlg = function showAboutDlg() {
      return about_dlg.value = false;
    }; //初始化编辑器


    service.init();
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      var _component_el_dropdown = _resolveComponent("el-dropdown");

      var _component_el_color_picker = _resolveComponent("el-color-picker");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_form = _resolveComponent("el-form");

      var _component_vuecmf_dialog = _resolveComponent("vuecmf-dialog");

      var _component_el_input_number = _resolveComponent("el-input-number");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor_tool_config), function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [['heading', 'font', 'text-height'].indexOf(item.icon) !== -1 ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 0,
          onCommand: item.fun,
          trigger: "click"
        }, {
          dropdown: _withCtx(function () {
            return [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, function (val, idx) {
                  return _openBlock(), _createBlock(_component_el_dropdown_item, {
                    command: val.key,
                    key: idx
                  }, {
                    default: _withCtx(function () {
                      return [_createElementVNode("div", {
                        innerHTML: val.value
                      }, null, 8, _hoisted_2)];
                    }),
                    _: 2
                  }, 1032, ["command"]);
                }), 128))];
              }),
              _: 2
            }, 1024)];
          }),
          default: _withCtx(function () {
            return [_createVNode(_component_el_button, {
              size: __props.size,
              title: item.tips
            }, {
              default: _withCtx(function () {
                return [_createVNode(_unref(FontAwesomeIcon), {
                  icon: item.icon
                }, null, 8, ["icon"])];
              }),
              _: 2
            }, 1032, ["size", "title"])];
          }),
          _: 2
        }, 1032, ["onCommand"])) : item.icon === 'glass-martini-alt' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "color_btn",
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_color_picker, {
              modelValue: _unref(color_value),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                return _isRef(color_value) ? color_value.value = $event : null;
              }),
              size: __props.size,
              onChange: item.fun,
              "show-alpha": "",
              predefine: _unref(predefine_colors)
            }, null, 8, ["modelValue", "size", "onChange", "predefine"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'glass-martini' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          class: "color_btn",
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_color_picker, {
              modelValue: _unref(bg_color_value),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                return _isRef(bg_color_value) ? bg_color_value.value = $event : null;
              }),
              size: __props.size,
              onChange: item.fun,
              "show-alpha": "",
              predefine: _unref(predefine_colors)
            }, null, 8, ["modelValue", "size", "onChange", "predefine"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'link' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[2] || (_cache[2] = function ($event) {
                return link_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'table' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[3] || (_cache[3] = function ($event) {
                return table_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'image' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 5,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[4] || (_cache[4] = function ($event) {
                return image_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'film' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 6,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[5] || (_cache[5] = function ($event) {
                return video_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'code' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 7,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[6] || (_cache[6] = function ($event) {
                return code_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : item.icon === 'question-circle' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 8,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: _cache[7] || (_cache[7] = function ($event) {
                return about_dlg.value = true;
              })
            }, null, 8, ["icon"])];
          }),
          _: 2
        }, 1032, ["size", "title"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 9,
          size: __props.size,
          title: item.tips
        }, {
          default: _withCtx(function () {
            return [_createVNode(_unref(FontAwesomeIcon), {
              icon: item.icon,
              onClick: item.fun
            }, null, 8, ["icon", "onClick"])];
          }),
          _: 2
        }, 1032, ["size", "title"]))], 64);
      }), 128))]), _createElementVNode("div", {
        class: "content",
        style: _normalizeStyle('width:100%; height:' + _unref(height)),
        contenteditable: "",
        ref_key: "editor_ref",
        ref: editor_ref
      }, null, 4), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(link_dlg),
        title: "添加超链接",
        onUpdateVisible: showLinkDlg
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            size: __props.size,
            inline: true
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "链接地址"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    size: __props.size,
                    modelValue: _unref(link_url),
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                      return _isRef(link_url) ? link_url.value = $event : null;
                    }),
                    placeholder: "请以http://或https://开头"
                  }, null, 8, ["size", "modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "打开方式"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(link_target),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                      return _isRef(link_target) ? link_target.value = $event : null;
                    }),
                    placeholder: "请选择",
                    size: __props.size
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_option, {
                        label: "新窗口",
                        value: "_blank"
                      }), _createVNode(_component_el_option, {
                        label: "当前窗口",
                        value: "_self"
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue", "size"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["size"])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[10] || (_cache[10] = function ($event) {
              return link_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["size"]), _createVNode(_component_el_button, {
            type: "primary",
            size: __props.size,
            onClick: _unref(linkEvent)
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          }, 8, ["size", "onClick"])];
        }),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(table_dlg),
        title: "插入表格",
        onUpdateVisible: showTableDlg
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            size: __props.size,
            inline: true
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("fieldset", null, [_hoisted_5, _createVNode(_component_el_form_item, {
                label: "宽度"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(table_width),
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                      return _isRef(table_width) ? table_width.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "行数"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(table_row),
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                      return _isRef(table_row) ? table_row.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "列数"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(table_col),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
                      return _isRef(table_col) ? table_col.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "边框"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_color_picker, {
                    modelValue: _unref(table_border_color),
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
                      return _isRef(table_border_color) ? table_border_color.value = $event : null;
                    }),
                    size: __props.size,
                    "show-alpha": "",
                    predefine: _unref(predefine_colors)
                  }, null, 8, ["modelValue", "size", "predefine"])];
                }),
                _: 1
              })]), _createElementVNode("fieldset", null, [_hoisted_6, _createVNode(_component_el_form_item, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(table_head),
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
                      return _isRef(table_head) ? table_head.value = $event : null;
                    }),
                    placeholder: "请选择",
                    size: __props.size
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_option, {
                        label: "无",
                        value: ""
                      }), _createVNode(_component_el_option, {
                        label: "第一行",
                        value: "first_row"
                      }), _createVNode(_component_el_option, {
                        label: "第一列",
                        value: "first_col"
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue", "size"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "背景色"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_color_picker, {
                    modelValue: _unref(table_head_bg_color),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
                      return _isRef(table_head_bg_color) ? table_head_bg_color.value = $event : null;
                    }),
                    size: __props.size,
                    "show-alpha": "",
                    predefine: _unref(predefine_colors)
                  }, null, 8, ["modelValue", "size", "predefine"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "文字颜色"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_color_picker, {
                    modelValue: _unref(table_head_color),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
                      return _isRef(table_head_color) ? table_head_color.value = $event : null;
                    }),
                    size: __props.size,
                    "show-alpha": "",
                    predefine: _unref(predefine_colors)
                  }, null, 8, ["modelValue", "size", "predefine"])];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["size"])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[18] || (_cache[18] = function ($event) {
              return table_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }, 8, ["size"]), _createVNode(_component_el_button, {
            type: "primary",
            size: __props.size,
            onClick: _unref(insertTableEvent)
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          }, 8, ["size", "onClick"])];
        }),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(image_dlg),
        title: "插入图片",
        onUpdateVisible: showImageDlg
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            size: __props.size,
            inline: true
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    size: __props.size,
                    modelValue: _unref(image_url),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
                      return _isRef(image_url) ? image_url.value = $event : null;
                    }),
                    placeholder: "请以http://或https://开头"
                  }, null, 8, ["size", "modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "宽度"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(image_width),
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
                      return _isRef(image_width) ? image_width.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "高度"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(image_height),
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
                      return _isRef(image_height) ? image_height.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "对齐"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(image_align),
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
                      return _isRef(image_align) ? image_align.value = $event : null;
                    }),
                    placeholder: "请选择",
                    size: __props.size
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_option, {
                        label: "左对齐",
                        value: "left"
                      }), _createVNode(_component_el_option, {
                        label: "右对齐",
                        value: "right"
                      }), _createVNode(_component_el_option, {
                        label: "顶对齐",
                        value: "top"
                      }), _createVNode(_component_el_option, {
                        label: "居中对齐",
                        value: "middle"
                      }), _createVNode(_component_el_option, {
                        label: "底对齐",
                        value: "bottom"
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue", "size"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["size"])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[23] || (_cache[23] = function ($event) {
              return image_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_9];
            }),
            _: 1
          }, 8, ["size"]), _createVNode(_component_el_button, {
            type: "primary",
            size: __props.size,
            onClick: _unref(insertImageEvent)
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }, 8, ["size", "onClick"])];
        }),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(video_dlg),
        title: "插入视频",
        onUpdateVisible: showVideoDlg
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            size: __props.size,
            inline: true
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("fieldset", null, [_hoisted_11, _createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    size: __props.size,
                    modelValue: _unref(video_url),
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
                      return _isRef(video_url) ? video_url.value = $event : null;
                    }),
                    placeholder: "请以http://或https://开头"
                  }, null, 8, ["size", "modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "宽度"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(video_width),
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
                      return _isRef(video_width) ? video_width.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "高度"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input_number, {
                    modelValue: _unref(video_height),
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
                      return _isRef(video_height) ? video_height.value = $event : null;
                    }),
                    precision: 0,
                    step: 1,
                    min: 1
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "对齐"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(video_align),
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
                      return _isRef(video_align) ? video_align.value = $event : null;
                    }),
                    placeholder: "请选择",
                    size: __props.size
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_option, {
                        label: "左对齐",
                        value: "left"
                      }), _createVNode(_component_el_option, {
                        label: "居中对齐",
                        value: "center"
                      }), _createVNode(_component_el_option, {
                        label: "右对齐",
                        value: "right"
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue", "size"])];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["size"])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[28] || (_cache[28] = function ($event) {
              return video_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_12];
            }),
            _: 1
          }, 8, ["size"]), _createVNode(_component_el_button, {
            type: "primary",
            size: __props.size,
            onClick: _unref(insertVideoEvent)
          }, {
            default: _withCtx(function () {
              return [_hoisted_13];
            }),
            _: 1
          }, 8, ["size", "onClick"])];
        }),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(code_dlg),
        title: "插入代码",
        onUpdateVisible: showCodeDlg
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _unref(code_content),
            "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
              return _isRef(code_content) ? code_content.value = $event : null;
            }),
            rows: 5,
            type: "textarea",
            placeholder: "请输入内容"
          }, null, 8, ["modelValue"])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[30] || (_cache[30] = function ($event) {
              return code_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_14];
            }),
            _: 1
          }, 8, ["size"]), _createVNode(_component_el_button, {
            type: "primary",
            size: __props.size,
            onClick: _unref(insertCodeEvent)
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 1
          }, 8, ["size", "onClick"])];
        }),
        _: 1
      }, 8, ["model_value"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(about_dlg),
        title: "关于",
        onUpdateVisible: showAboutDlg
      }, {
        content: _withCtx(function () {
          return [_hoisted_16];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
            type: "default",
            size: __props.size,
            onClick: _cache[31] || (_cache[31] = function ($event) {
              return about_dlg.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_18];
            }),
            _: 1
          }, 8, ["size"])])];
        }),
        _: 1
      }, 8, ["model_value"])], 64);
    };
  }
}));